import { useTranslation } from 'react-i18next';

import ConfirmModal from '../../../../../styledComponents/ConfirmModal/ConfirmModal';
import {
  Description,
  Name,
} from '../../../Modals/Common/memberOverviewModals.styles';
import { DELETE_SR_FAMILY_MEMBER_MODAL_NAME } from './deleteSRFamilyMemberModal.const';
import { useDeleteSRFamilyMemberModal } from './deleteSRFamilyMemberModal.hooks';

type DeleteSRFamilyMemberModalProps = {
  onFamilyMemberRemoved?: () => void;
  id?: string;
};

const DeleteSRFamilyMemberModal = ({
  onFamilyMemberRemoved,
  id,
}: DeleteSRFamilyMemberModalProps) => {
  const { t } = useTranslation();
  const { onBackHandler, name, isDeleting, deleteSecondaryMemberHandler } =
    useDeleteSRFamilyMemberModal({ onFamilyMemberRemoved, id });
  return (
    <ConfirmModal
      buttons={[
        {
          action: onBackHandler,
          type: 'back',
          styleType: 'light1',
          disabled: isDeleting,
        },
        {
          action: deleteSecondaryMemberHandler,
          type: 'delete',
          styleType: 'background-delete',
          isProcessing: isDeleting,
        },
      ]}
      name={DELETE_SR_FAMILY_MEMBER_MODAL_NAME + id}
      disabled={isDeleting}
      title={t('headers.remove-family-member')}
    >
      <Description>{t('phrase.confirm-remove-family-member')}</Description>
      <Name>{name}</Name>
    </ConfirmModal>
  );
};

export default DeleteSRFamilyMemberModal;
